import { FEATURE_TO_TITLE } from 'hooks/dialogs/cluster/constants';

import {
  AgentSetupBlock,
  AgentSetupBlockProps,
} from './_components/AgentSetupBlock';
import { AgentSetupCompleteBlock } from './_components/AgentSetupCompleteBlock';
import FeatureLabel from './_components/FeatureLabel';

type SetupProps = Pick<
  AgentSetupBlockProps,
  'checked' | 'onChange' | 'hasBeenInstalled' | 'showCheckbox'
>;

type CompleteProps = {
  checked?: boolean;
};

const heading = FEATURE_TO_TITLE.networkCostMetrics;

export const AgentNetworkCostSetup = (props: SetupProps) => {
  return (
    <AgentSetupBlock
      heading={heading}
      description="Visualize network traffic costs and identify optimization opportunities across your cluster"
      isNestedBlock
      labelChip={<FeatureLabel />}
      testId="network-cost-metrics"
      {...props}
    />
  );
};

export const AgentNetworkCostComplete = ({ checked }: CompleteProps) => {
  return (
    <AgentSetupCompleteBlock
      heading={heading}
      testId="agent-network-costs-complete"
      isNestedBlock
      checked={checked}
    />
  );
};
